module.exports = __webpack_public_path__ + "static/media/plus-icon.ecae98ca.svg";